import React from 'react';
import { Box, Theme, Typography } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/styles';
import { History } from '@material-ui/icons';
import { PushHistoryTable } from './PushHistoryTable';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      paddingLeft: 40,
      paddingRight: 40,
      paddingTop: 20,
      backgroundColor: '#F9F9F9',
      minHeight: 'calc(100% - 20px)',
    },
    heading: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingBottom: '8px',
      borderBottom: '1px solid #efefef',
    },
    headingTitle: {
      color: theme.color.grey.neutralBrand900,
      fontWeight: 600,
      paddingBottom: '5px',
      fontSize: 20,
    },
    containerPanel: {
      background: 'white',
      paddingTop: '1.25rem',
      paddingBottom: '1.25rem',
      paddingLeft: '1.875rem',
      paddingRight: '1.875rem',
      marginTop: '2.25rem',
    },
    headingPanel: {
      fontWeight: 600,
      fontSize: '16px',
      display: 'flex',
      alignItems: 'center',
    },
    bodyPanel: {
      fontSize: '14px',
      color: '#808080',
    },
  })
);

export const AdminConsolePushHistory = () => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box className={classes.heading}>
        <Box>
          <Typography variant='h2' className={classes.headingTitle}>
            Push History
          </Typography>
          <Typography variant='body2'>{'Updates you have sent and how each sub-account resolved them'}</Typography>
        </Box>
      </Box>

      <Box className={classes.containerPanel}>
        <Typography className={classes.headingPanel}>
          <History style={{ fontSize: '14px', paddingRight: '5px' }} /> Pushes
        </Typography>
        <Typography variant='body2' className={classes.bodyPanel}>
          {'Each row is one push to one sub-account'}
        </Typography>
        <PushHistoryTable emptyMessage='You have not pushed any updates yet.' />
      </Box>
    </Box>
  );
};
